export default __webpack_public_path__ + "static/media/moon_stars.e304c34d.png";